import React, { useMemo } from 'react';
import { createStore, Provider } from 'jotai';
import { noop } from 'lodash';
import { generateAllCategory } from '../utils';
import * as atoms from './atom';

const useInitStore = (props: atoms.ManagementStoreProps) => {
  const {
    dataSource,
    filterMeta,
    disabledDataSources = [],
    enableApplyAction = false,
    filterEditor = null,
    onEditFilter = noop,
    onEnableFilter = noop,
    onCreateFilter = noop,
    onDeleteFilter = noop as any,
    onDataSourceChange = noop,
    onFilterEditorReset = noop,
    onClose = noop,
    onFilterMetaRetry = noop,
    onSavedFiltersRetry = noop,
    onApplyNotify = noop,
  } = props;

  const store = useMemo(() => {
    const store = createStore();
    store.set(atoms.dataSource, dataSource);
    if (filterMeta) {
      store.set(atoms.filterMeta, filterMeta);
      store.set(atoms.currentCategory, generateAllCategory());
    }
    store.set(atoms.callbacks, {
      onEditFilter,
      onCreateFilter,
      onDeleteFilter,
      onDataSourceChange,
      onFilterEditorReset,
      onClose,
      onEnableFilter,
      onFilterMetaRetry,
      onSavedFiltersRetry,
      onApplyNotify,
    });
    store.set(atoms.controlVariables, {
      disabledDataSources,
      enableApplyAction,
    });
    store.set(atoms.filterEditor, filterEditor);
    return store;
  }, [
    dataSource,
    filterMeta,
    disabledDataSources,
    enableApplyAction,
    onEditFilter,
    onCreateFilter,
    onDeleteFilter,
    onDataSourceChange,
    onFilterEditorReset,
    onClose,
    onEnableFilter,
    onFilterMetaRetry,
    onSavedFiltersRetry,
    onApplyNotify,
  ]);

  return store;
};

export const ManagementProvider = (
  props: atoms.ManagementStoreProps & {
    children: React.ReactNode;
  },
) => {
  const store = useInitStore(props);

  return <Provider store={store}>{props.children}</Provider>;
};
